import { render, staticRenderFns } from "./SourceModal.vue?vue&type=template&id=31c247f6"
import script from "./SourceModal.vue?vue&type=script&lang=ts"
export * from "./SourceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c247f6')) {
      api.createRecord('31c247f6', component.options)
    } else {
      api.reload('31c247f6', component.options)
    }
    module.hot.accept("./SourceModal.vue?vue&type=template&id=31c247f6", function () {
      api.rerender('31c247f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/customer-source/SourceModal.vue"
export default component.exports